<div class="col-xs-3 table--grid__actions table--grid__actions--hover">
    <div class="btn-group dropdown" dropdown>
        <button class="btn btn-link table--grid__actions__ellipsis dropdown-toggle" dropdownToggle>
            <i class="fas fa-ellipsis-h table--grid__actions__ellipsis__icon"
               aria-hidden="true"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-right table--grid__actions__links">
            <li class="dropdown-item" (click)="editData.emit()">
                <a class="btn btn-link table--grid__action-btn">
                    <i class="fas fa-pencil-alt table--grid__actions__links__icon" aria-hidden="true"
                       title="{{ 'Edit' | translate }}"
                       attr.name="{{ 'Edit' | translate }}"></i>
                </a>
            </li>
            <li class="dropdown-item" (click)="deleteData.emit()">
                <a class="btn btn-link table--grid__action-btn">
                    <i class="far fa-trash-alt table--grid__actions__links__icon"
                       title="{{ 'Delete' | translate }}"
                       attr.name="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                </a>
            </li>
        </ul>
    </div>
</div>